
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcdms.vcdocument.factory:DocumentHelper
   *
   * @description
   *
   */
  angular
    .module('vcdms.vcdocument')
    .factory('DocumentHelper', DocumentHelper);
  
  
  DocumentHelper.$inject = ['Document', '$uibModal', '$log', 'Rlog'];
  
  function DocumentHelper(Document, $uibModal, $log, Rlog) {
    let DocumentHelperBase = {};
    
    DocumentHelperBase.editDocument = editDocument;
    DocumentHelperBase.addDocument = addDocument;
    
    
    function addDocument(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><documentform document="vm.document" parentsave="vm.childsave(document)" oncancel="vm.cancel()"></documentnew></div>',
        controllerAs: 'documentaCtrl',
        controller: ['document', function () {
          let vm = this;
          vm.document = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(document) {
            Document.$create(document).$then(function (newdocument) {
              vm.created = true;
              success(newdocument);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ document-helper.addDocument: ', err);
              Rlog.error('vcutils.document', 'document-helper.addDocument', 'Creation of new SV failed: ', {document: document});
              error(err);
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          document: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }
    
    
    function editDocument(ldocument) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><documentform document="documenteCtrl.document" parentsave="documenteCtrl.childsave(document)" oncancel="documenteCtrl.cancel()"></documentform></div>',
        controllerAs: 'documenteCtrl',
        controller: ['document', function (sdocument) {
          let vm = this;
          vm.document = sdocument;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(doc) {
            // vm.document = angular.copy(doc);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in doc) {
              if (doc.hasOwnProperty(key)) {
                vm.document[key] = doc[key];
              }
            }
            
            if (vm.document.$hasPendingActions()) {
              vm.document.$cancel();
              vm.document.$save();
              cancel();
            }
            else {
              vm.document.$save();
              dialog.close();
            }
          }
          
          
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          document: function () {
            return ldocument;
          }
        },
        size: 'lg'
      });
      return dialog;
    }
    
    return DocumentHelperBase;
  }
}());
